import { combineReducers, configureStore } from '@reduxjs/toolkit';
import userSlice from "./slices/user";
import networkSlice from "./slices/network";
import authSlice from "./slices/auth";
import dbSlice from "./slices/db";
import { useDispatch } from 'react-redux'

const rootReducer = combineReducers({
    user: userSlice,
    network: networkSlice,
    auth: authSlice,
    db: dbSlice,
})

const store = configureStore({
    reducer: rootReducer,
    devTools: true,
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
export const useAppDispatch: () => AppDispatch = useDispatch

export default store;